import React, { useMemo } from 'react';
import type { EventNameNavProps } from '../components/EventNameNav';
import { EventNameNav } from '../components/EventNameNav';
import type { WebsiteHeaderLayout_PhotoTrio } from '@shared/types/WebsiteHeaderSettings.types';
import { HeaderPhoto } from '../components/HeaderPhoto/HeaderPhoto';
import { PhotoTrio } from '@apps/guest/packages/layout-engine/widgets/Custom/components';

interface PhotoTrioLayoutProps extends EventNameNavProps {
  websiteHeader: WebsiteHeaderLayout_PhotoTrio;
  showPlaceholder?: boolean;
}

export const PhotoTrioLayout = (props: PhotoTrioLayoutProps) => {
  const { websiteHeader, showPlaceholder = false, ...restProps } = props;

  const photos = useMemo(() => {
    return websiteHeader.headerPhoto.photos?.map(photo => ({ ...photo, id: photo.id, photoUrl: photo.url })) || [];
  }, [websiteHeader]);

  return (
    <EventNameNav
      eventDisplayName={websiteHeader.eventDisplayName}
      {...restProps}
    >
      <HeaderPhoto
        websiteHeader={websiteHeader}
        pageSlug={restProps.pageSlug}
        pageType={restProps.page}
        showPlaceholder={showPlaceholder}
      >
        <PhotoTrio
          photos={photos}
          showPlaceholder={showPlaceholder}
          container="viewport"
        />
      </HeaderPhoto>
    </EventNameNav>
  );
};
